import React from "react";
import { Star, Quote } from "lucide-react";
import { IMG, RESERVE_URL } from "../mock";

export default function About() {
  return (
    <section id="gilles" className="relative py-20 md:py-28">
      <div className="orb" style={{ width: 380, height: 380, background: "#0a4d68", left: -80, top: 100, opacity: 0.25 }} />
      <div className="relative mx-auto max-w-7xl px-5 grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal order-2 lg:order-1">
          <span className="kicker">Qui suis-je</span>
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white mt-3">
            Gilles Delieuze
          </h2>
          <div className="text-aqua text-sm uppercase tracking-widest mt-2">
            Mentor · Auteur · Enseignant
          </div>
          <p className="mt-6 text-white/70 leading-relaxed">
            Praticien en soins énergétiques et guide spirituel. Cela fait 25 ans
            que j'accompagne des personnes en quête de mieux-être et 17 ans que je
            suis un expert Dauphins.
          </p>
          <div className="mt-6 glass rounded-2xl p-6">
            <Quote className="h-6 w-6 text-gold/70" />
            <p className="mt-3 text-white/80 italic leading-relaxed">
              En 2007, à 3h33, je reçois un « appel » mystique. Une énergie se
              présente sous le nom de « Maîtres Dauphins ». Cet appel m'a permis de
              sortir la tête de l'eau. Aujourd'hui, je leur dédie ma vie pour qu'ils
              te transmettent leur message.
            </p>
          </div>
          <div className="mt-6 flex items-center gap-1.5 text-gold">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="h-4 w-4 fill-current" />
            ))}
            <span className="ml-2 text-white/60 text-sm">
              Une interview à plus d'un demi-million de vues
            </span>
          </div>
          <div className="mt-8">
            <a href={RESERVE_URL} target="_blank" rel="noreferrer" className="btn-gold px-7 py-4 inline-block">
              Je rejoins l'aventure
            </a>
          </div>
        </div>

        <div className="reveal order-1 lg:order-2">
          <div className="relative mx-auto max-w-[440px]">
            <div className="absolute -inset-5 rounded-[2rem] bg-[#e8c874]/10 blur-2xl" />
            <div className="relative rounded-[2rem] overflow-hidden border border-[#e8c874]/25 floaty-slow">
              <img src={IMG.gilles} alt="Gilles Delieuze" className="w-full object-cover" loading="lazy" />
            </div>
            <div className="absolute -bottom-5 -right-3 glass-strong rounded-2xl px-5 py-3">
              <div className="font-display text-2xl text-gold">17 ans</div>
              <div className="text-[11px] uppercase tracking-widest text-white/55">expert Dauphins</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
